import { memo } from 'react';
import PropTypes from 'prop-types';

import { PROJECT_TYPE } from 'src/data/project';

import { getProjectTypeIcon } from './utils';

export const ProjectTypeIcon = memo(({ className, projectType }) => {
  const Icon = getProjectTypeIcon(projectType);

  return <Icon className={className} />;
});

ProjectTypeIcon.propTypes = {
  className: PropTypes.string,
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)).isRequired,
};

ProjectTypeIcon.defaultProps = {
  className: null,
};
